var map = {
	"./assets/case3-2.jpeg": 83061,
	"./assets/en/case3-2.jpeg": 75004,
	"pages/home/assets/case3-2.jpeg": 83061,
	"pages/home/assets/en/case3-2.jpeg": 75004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72254;